// extracted by mini-css-extract-plugin
export default {"GreenCheckmark":"GreenCheckmark_GreenCheckmark__PyQRS"};